import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant =
  | 'primary' | 'secondary' | 'outline' | 'ghost' | 'accent' | 'destructive';

export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: ReactNode;
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary:     'bg-primary text-primary-foreground border-transparent hover:opacity-90',
  secondary:   'bg-foreground text-background border-transparent hover:opacity-90',
  outline:     'bg-transparent text-foreground border-border-strong hover:bg-muted',
  ghost:       'bg-transparent text-foreground border-transparent hover:bg-muted',
  accent:      'bg-accent text-accent-foreground border-transparent hover:opacity-90',
  destructive: 'bg-clay text-white border-transparent hover:opacity-90',
};

const SIZE_CLASSES: Record<ButtonSize, string> = {
  sm: 'px-3 py-[7px] text-[13px]',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-[22px] py-3 text-[15px]',
};

export function Button({
  variant = 'primary',
  size = 'md',
  className,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      className={[
        'inline-flex items-center justify-center rounded-sm border font-sans font-medium',
        'transition-opacity cursor-pointer',
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        className,
      ].filter(Boolean).join(' ')}
    >
      {children}
    </button>
  );
}
